import { offColor } from 'src/styling/variables'

export default {
  cashbox: {
    height: 36
  },
  tBody: {
    maxHeight: '65vh',
    overflow: 'auto'
  },
  tableWidth: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 1
  },
  descriptions: {
    color: offColor,
    marginTop: 0
  },
  cashboxReset: {
    color: offColor,
    margin: [[13, 0, -5, 20]]
  },
  selection: {
    marginRight: 12
  },
  downloadLogsButton: {
    marginLeft: 13
  }
}
